import React, { Component } from "react";
import API from "./ApiInterface";
import { _checkStrings } from "./common/sanitizeInputs";
import { DateTime } from "luxon";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiAlert from "@material-ui/lab/Alert";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

function formatDate(date) {
  return DateTime.fromJSDate(date, { zone: "America/Los_Angeles" }).toFormat(
    "yyyy-MM-dd"
  );
}

class FeatureAccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: this.props.location.state.userInfo,

      eapFeatures: [],
      nonEapFeatures: [],

      parentTabValue: 0,
      tabValue: 0,

      email: "",
      selectedFeature: "",
      selectedFeatureEap: "",
      endDate: new Date(),
      loading: false,

      grantReason: "",

      bulkCsvFile: null,
      bulkSelectedFeature: "",
      bulkSelectedFeatureEap: "",
      bulkEndDate: new Date(),
      bulkLoading: false,

      bulkGrantReason: "",

      bulkFailures: null,
      bulkSuccesses: null,
      openBulkFailuresDialog: false,

      snackbarOpen: false,
      snackbarMessage: "",
      snackbarSeverity: "success",
      snackbarShowErrorDetails: false,
    };
  }

  componentDidMount() {
    const token = this.state.userInfo.token;
    if (!token) {
      this.showSnackbar("No auth token provided.", "error");
      return;
    }

    const permissions = this.state.userInfo.permissions;

    if (permissions.includes("MEA") && permissions.includes("MF")) {
      Promise.all([API.getEarlyAccessFeatures(token), API.getFeatures(token)])
        .then(([eapResp, allResp]) => {
          if (eapResp.status === 200 && allResp.status === 200) {
            const eapFeats = eapResp.data.features || [];
            const allFeats = allResp.data.features || [];
            const eapIds = new Set(eapFeats.map((f) => f.featureId));
            const nonEapFeats = allFeats.filter(
              (f) => !eapIds.has(f.featureId)
            );
            this.setState({
              eapFeatures: eapFeats,
              nonEapFeatures: nonEapFeats,
            });
          } else {
            this.showSnackbar(
              `Failed to load features: ${
                eapResp.status !== 200
                  ? eapResp.data.errorDescription || eapResp.status
                  : allResp.data.errorDescription || allResp.status
              }`,
              "error"
            );
          }
        })
        .catch(() => {
          this.showSnackbar("Failed to load features.", "error");
        });
    } else if (permissions.includes("MEA") && !permissions.includes("MF")) {
      Promise.all([API.getEarlyAccessFeatures(token)])
        .then(([eapResp]) => {
          if (eapResp.status === 200) {
            const eapFeats = eapResp.data.features || [];
            this.setState({ eapFeatures: eapFeats });
          } else {
            this.showSnackbar(
              `Failed to load features: ${
                eapResp.data.errorDescription || eapResp.status
              }`,
              "error"
            );
          }
        })
        .catch(() => {
          this.showSnackbar("Failed to load features.", "error");
        });
    } else if (!permissions.includes("MEA") && permissions.includes("MF")) {
      Promise.all([API.getFeatures(token)])
        .then(([allResp]) => {
          if (allResp.status === 200) {
            const nonEapFeats = allResp.data.features || [];
            this.setState({ nonEapFeatures: nonEapFeats });
          } else {
            this.showSnackbar(
              `Failed to load features: ${
                allResp.data.errorDescription || allResp.status
              }`,
              "error"
            );
          }
        })
        .catch(() => {
          this.showSnackbar("Failed to load features.", "error");
        });
    } else this.showSnackbar("Unathorized!", "error");
  }

  showSnackbar = (message, severity, showErrorDetails = false) => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message,
      snackbarSeverity: severity,
      snackbarShowErrorDetails: showErrorDetails,
    });
  };
  handleSnackbarClose = () => {
    this.setState({ snackbarOpen: false });
  };

  handleParentTabChange = (_, newVal) => {
    this.setState({ parentTabValue: newVal, tabValue: 0, snackbarOpen: false });
  };

  handleTabChange = (_, newVal) => {
    this.setState({ tabValue: newVal, snackbarOpen: false });
  };

  handleEmailChange = (e) => this.setState({ email: e.target.value });
  handleFeatureChange = (e) =>
    this.setState({ selectedFeature: e.target.value });
  handleEapFeatureChange = (e) =>
    this.setState({ selectedFeatureEap: e.target.value });
  handleDateChange = (date) => this.setState({ endDate: date });
  handleGrantReasonChange = (e) =>
    this.setState({ grantReason: e.target.value });

  handleBulkFeatureChange = (e) =>
    this.setState({ bulkSelectedFeature: e.target.value });
  handleBulkEapFeatureChange = (e) =>
    this.setState({ bulkSelectedFeatureEap: e.target.value });
  handleBulkDateChange = (date) => this.setState({ bulkEndDate: date });
  handleBulkGrantReasonChange = (e) =>
    this.setState({ bulkGrantReason: e.target.value });
  handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      this.setState({ bulkCsvFile: e.target.files[0] });
    }
  };

  handleSubmitEAP = (e) => {
    e.preventDefault();
    const { email, selectedFeatureEap, endDate, userInfo } = this.state;
    const token = userInfo.token;
    if (!email || !selectedFeatureEap || !endDate) {
      this.showSnackbar("All fields are required.", "error");
      return;
    }
    const sanitizedEmail = _checkStrings(email);
    const formattedDate = formatDate(endDate);
    this.setState({ loading: true });
    API.addEapUserByEmail(
      token,
      sanitizedEmail,
      formattedDate,
      selectedFeatureEap
    )
      .then((response) => {
        if (response.status === 201) {
          const msg = response.data.messages?.[0] || "User added successfully!";
          this.showSnackbar(msg, "success");
          this.setState({
            loading: false,
            email: "",
            selectedFeatureEap: "",
            endDate: new Date(),
          });
        } else if (response.status === 400) {
          this.showSnackbar(
            response.data.errorDescription || "Failed to add user.",
            "error"
          );
          this.setState({ loading: false });
        } else {
          this.showSnackbar("Unexpected response from server.", "error");
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        this.showSnackbar(err.message || "Failed to add user.", "error");
        this.setState({ loading: false });
      });
  };

  handleSubmitNonEAP = (e) => {
    e.preventDefault();
    const { email, selectedFeature, endDate, grantReason, userInfo } =
      this.state;
    const token = userInfo.token;
    if (!email || !selectedFeature || !endDate || !grantReason) {
      this.showSnackbar("All fields are required.", "error");
      return;
    }
    const sanitizedEmail = _checkStrings(email);
    const formattedDate = formatDate(endDate);
    this.setState({ loading: true });
    API.addUserFeatureByEmail(
      token,
      sanitizedEmail,
      selectedFeature,
      formattedDate,
      grantReason
    )
      .then((response) => {
        if (response.status === 201) {
          const msg =
            response.data.messages?.[0] || "User feature granted successfully!";
          this.showSnackbar(msg, "success");
          this.setState({
            loading: false,
            email: "",
            selectedFeature: "",
            endDate: new Date(),
            grantReason: "",
          });
        } else if (response.status === 400) {
          this.showSnackbar(
            response.data.errorDescription || "Failed to grant feature.",
            "error"
          );
          this.setState({ loading: false });
        } else {
          this.showSnackbar("Unexpected response from server.", "error");
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        this.showSnackbar(err.message || "Failed to grant feature.", "error");
        this.setState({ loading: false });
      });
  };

  handleBulkSubmitEAP = (e) => {
    e.preventDefault();
    const { bulkCsvFile, bulkSelectedFeatureEap, bulkEndDate, userInfo } =
      this.state;
    const token = userInfo.token;
    if (!bulkCsvFile || !bulkSelectedFeatureEap || !bulkEndDate) {
      this.showSnackbar("All fields are required for bulk upload.", "error");
      return;
    }
    const formattedDate = formatDate(bulkEndDate);
    this.setState({
      bulkLoading: true,
      bulkFailures: null,
      bulkSuccesses: null,
    });
    API.bulkAddEapUsers(
      token,
      bulkCsvFile,
      bulkSelectedFeatureEap,
      formattedDate
    )
      .then((response) => this._handleBulkResponse(response))
      .catch((err) => {
        this.showSnackbar(err.message || "Bulk upload failed.", "error");
        this.setState({ bulkLoading: false });
      });
  };

  handleBulkSubmitNonEAP = (e) => {
    e.preventDefault();
    const {
      bulkCsvFile,
      bulkSelectedFeature,
      bulkEndDate,
      bulkGrantReason,
      userInfo,
    } = this.state;
    const token = userInfo.token;
    if (
      !bulkCsvFile ||
      !bulkSelectedFeature ||
      !bulkEndDate ||
      !bulkGrantReason
    ) {
      this.showSnackbar("All fields are required for bulk upload.", "error");
      return;
    }
    const formattedDate = formatDate(bulkEndDate);
    this.setState({
      bulkLoading: true,
      bulkFailures: null,
      bulkSuccesses: null,
    });
    API.bulkAddUserFeaturesByEmail(
      token,
      bulkCsvFile,
      bulkSelectedFeature,
      formattedDate,
      bulkGrantReason
    )
      .then((response) => this._handleBulkResponse(response))
      .catch((err) => {
        this.showSnackbar(err.message || "Bulk upload failed.", "error");
        this.setState({ bulkLoading: false });
      });
  };

  _handleBulkResponse = (response) => {
    const { status, data } = response;
    if (status === 400) {
      this.showSnackbar(
        data.errorDescription || "Bulk upload failed.",
        "error"
      );
      return this.setState({ bulkLoading: false });
    }
    const { success, failure, failures, successes } = data;
    const total = success + failure;
    const hasDetails = Boolean(
      (successes && Object.keys(successes).length) ||
        (failures && Object.keys(failures).length)
    );
    if (status === 201) {
      this.showSnackbar(
        `${success}/${total} records inserted successfully.`,
        "success",
        hasDetails
      );
      this.setState({
        bulkLoading: false,
        bulkCsvFile: null,
        bulkSelectedFeature: "",
        bulkSelectedFeatureEap: "",
        bulkEndDate: new Date(),
        bulkGrantReason: "",
        bulkFailures: failures,
        bulkSuccesses: successes,
      });
    } else if (status === 207) {
      this.showSnackbar(
        `${success}/${total} inserted, ${failure}/${total} failed.`,
        "warning",
        true
      );
      this.setState({
        bulkLoading: false,
        bulkFailures: failures,
        bulkSuccesses: successes,
      });
    } else if (status === 422) {
      this.showSnackbar(
        `0/${total} inserted. All records failed.`,
        "error",
        true
      );
      this.setState({
        bulkLoading: false,
        bulkFailures: failures,
        bulkSuccesses: successes,
      });
    } else {
      this.showSnackbar("Unexpected response from server.", "error");
      this.setState({ bulkLoading: false });
    }
  };

  handleCloseBulkFailuresDialog = () => {
    this.setState({ openBulkFailuresDialog: false });
  };

  renderBulkDetailsDialog() {
    const { bulkFailures, bulkSuccesses, openBulkFailuresDialog } = this.state;
    if (!openBulkFailuresDialog || (!bulkFailures && !bulkSuccesses))
      return null;

    return (
      <Dialog
        open
        onClose={this.handleCloseBulkFailuresDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Details</DialogTitle>
        <DialogContent>
          {bulkSuccesses && (
            <>
              <h3>Successful</h3>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Message</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries(bulkSuccesses).map(([email, msg]) => (
                    <TableRow key={email}>
                      <TableCell>{email}</TableCell>
                      <TableCell>{msg}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </>
          )}
          {bulkFailures && (
            <>
              <h3>Failed</h3>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Error</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries(bulkFailures).map(([email, err]) => (
                    <TableRow key={email}>
                      <TableCell>{email}</TableCell>
                      <TableCell>{err}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCloseBulkFailuresDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const {
      userInfo,
      parentTabValue,
      tabValue,
      eapFeatures,
      nonEapFeatures,
      email,
      selectedFeature,
      selectedFeatureEap,
      endDate,
      grantReason,
      loading,
      bulkCsvFile,
      bulkSelectedFeature,
      bulkSelectedFeatureEap,
      bulkEndDate,
      bulkGrantReason,
      bulkLoading,
      snackbarOpen,
      snackbarMessage,
      snackbarSeverity,
      snackbarShowErrorDetails,
    } = this.state;

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <>
        <div style={{ maxWidth: 600, margin: "1em", padding: "1em" }}>
          <Tabs
            value={parentTabValue}
            onChange={this.handleParentTabChange}
            TabIndicatorProps={{ style: { backgroundColor: "#DC4C64" } }}
            style={{ marginBottom: "1em", justifyContent: "flex-start" }}
            variant="fullWidth"
          >
            <Tab label="Add EAP Users" />
            <Tab label="Grant non‑EAP Feature" />
          </Tabs>

          <TabPanel value={parentTabValue} index={0}>
            {userInfo.permissions.includes("MEA") ? (
              <>
                <Tabs
                  value={tabValue}
                  onChange={this.handleTabChange}
                  TabIndicatorProps={{ style: { backgroundColor: "#DC4C64" } }}
                  style={{ marginBottom: "1em", justifyContent: "flex-start" }}
                >
                  <Tab label="Add Single User" />
                  <Tab label="Add Multiple Users" />
                </Tabs>

                <TabPanel value={tabValue} index={0}>
                  <form
                    onSubmit={this.handleSubmitEAP}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <TextField
                      label="Email"
                      value={email}
                      onChange={this.handleEmailChange}
                      style={{ marginBottom: "1em" }}
                    />
                    <FormControl style={{ marginBottom: "1em" }}>
                      <InputLabel>Feature</InputLabel>
                      <Select
                        value={selectedFeatureEap}
                        onChange={this.handleEapFeatureChange}
                      >
                        {eapFeatures.map((f) => (
                          <MenuItem key={f.featureId} value={f.featureId}>
                            {!f.name || f.name === "" ? f.featureId : f.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <KeyboardDatePicker
                      margin="normal"
                      label="End Date"
                      format="yyyy-MM-dd"
                      value={endDate}
                      onChange={this.handleDateChange}
                      style={{ marginBottom: "1.5em" }}
                    />
                    <Button
                      type="submit"
                      color="primary"
                      variant="outlined"
                      disabled={loading}
                      style={{ alignSelf: "flex-start" }}
                    >
                      {loading ? (
                        <CircularProgress size={24} />
                      ) : (
                        "Add EAP User"
                      )}
                    </Button>
                  </form>
                </TabPanel>

                <TabPanel value={tabValue} index={1}>
                  <form
                    onSubmit={this.handleBulkSubmitEAP}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <FormControl style={{ marginBottom: "1em" }}>
                      <InputLabel>Feature</InputLabel>
                      <Select
                        value={bulkSelectedFeatureEap}
                        onChange={this.handleBulkEapFeatureChange}
                      >
                        {eapFeatures.map((f) => (
                          <MenuItem key={f.featureId} value={f.featureId}>
                            {!f.name || f.name === "" ? f.featureId : f.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <KeyboardDatePicker
                      margin="normal"
                      label="End Date"
                      format="yyyy-MM-dd"
                      value={bulkEndDate}
                      onChange={this.handleBulkDateChange}
                      style={{ marginBottom: "1em" }}
                    />
                    <input
                      accept=".csv"
                      style={{ display: "none" }}
                      id="eap-bulk-file"
                      type="file"
                      onChange={this.handleFileChange}
                    />
                    <label htmlFor="eap-bulk-file">
                      <Button
                        variant="outlined"
                        component="span"
                        startIcon={<CloudUploadIcon />}
                        style={{ marginBottom: "1.5em" }}
                      >
                        {bulkCsvFile ? bulkCsvFile.name : "Upload CSV"}
                      </Button>
                    </label>
                    <Button
                      type="submit"
                      color="primary"
                      variant="outlined"
                      disabled={bulkLoading}
                      style={{ alignSelf: "flex-start" }}
                    >
                      {bulkLoading ? (
                        <CircularProgress size={24} />
                      ) : (
                        "Add Users"
                      )}
                    </Button>
                  </form>
                </TabPanel>
              </>
            ) : (
              <Box p={2}>Unauthorized: Permission to manage Early Access required. Please contact Admin</Box>
            )}
          </TabPanel>

          <TabPanel value={parentTabValue} index={1}>
            {userInfo.permissions.includes("MF") ? (
              <>
                <Tabs
                  value={tabValue}
                  onChange={this.handleTabChange}
                  TabIndicatorProps={{ style: { backgroundColor: "#DC4C64" } }}
                  style={{ marginBottom: "1em", justifyContent: "flex-start" }}
                >
                  <Tab label="Single User" />
                  <Tab label="Multiple Users" />
                </Tabs>

                <TabPanel value={tabValue} index={0}>
                  <form
                    onSubmit={this.handleSubmitNonEAP}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <TextField
                      label="Email"
                      value={email}
                      onChange={this.handleEmailChange}
                      style={{ marginBottom: "1em" }}
                    />
                    <FormControl style={{ marginBottom: "1em" }}>
                      <InputLabel>Feature</InputLabel>
                      <Select
                        value={selectedFeature}
                        onChange={this.handleFeatureChange}
                      >
                        {nonEapFeatures.map((f) => (
                          <MenuItem key={f.featureId} value={f.featureId}>
                            {!f.name || f.name === "" ? f.featureId : f.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <KeyboardDatePicker
                      margin="normal"
                      label="End Date"
                      format="yyyy-MM-dd"
                      value={endDate}
                      onChange={this.handleDateChange}
                      style={{ marginBottom: "1em" }}
                    />
                    <TextField
                      label="Grant Reason"
                      multiline
                      value={grantReason}
                      onChange={this.handleGrantReasonChange}
                      style={{ marginBottom: "1.5em" }}
                    />
                    <Button
                      type="submit"
                      variant="outlined"
                      color="primary"
                      disabled={loading}
                      style={{ alignSelf: "flex-start" }}
                    >
                      {loading ? (
                        <CircularProgress size={24} />
                      ) : (
                        "Grant Feature"
                      )}
                    </Button>
                  </form>
                </TabPanel>

                <TabPanel value={tabValue} index={1}>
                  <form
                    onSubmit={this.handleBulkSubmitNonEAP}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <FormControl style={{ marginBottom: "1em" }}>
                      <InputLabel>Feature</InputLabel>
                      <Select
                        value={bulkSelectedFeature}
                        onChange={this.handleBulkFeatureChange}
                      >
                        {nonEapFeatures.map((f) => (
                          <MenuItem key={f.featureId} value={f.featureId}>
                            {!f.name || f.name === "" ? f.featureId : f.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <KeyboardDatePicker
                      margin="normal"
                      label="End Date"
                      format="yyyy-MM-dd"
                      value={bulkEndDate}
                      onChange={this.handleBulkDateChange}
                      style={{ marginBottom: "1em" }}
                    />
                    <TextField
                      label="Grant Reason"
                      multiline
                      value={bulkGrantReason}
                      onChange={this.handleBulkGrantReasonChange}
                      style={{ marginBottom: "1em" }}
                    />
                    <input
                      accept=".csv"
                      style={{ display: "none" }}
                      id="noneap-bulk-file"
                      type="file"
                      onChange={this.handleFileChange}
                    />
                    <label htmlFor="noneap-bulk-file">
                      <Button
                        variant="outlined"
                        component="span"
                        startIcon={<CloudUploadIcon />}
                        style={{ marginBottom: "1.5em" }}
                      >
                        {bulkCsvFile ? bulkCsvFile.name : "Upload CSV"}
                      </Button>
                    </label>
                    <Button
                      type="submit"
                      color="primary"
                      variant="outlined"
                      disabled={bulkLoading}
                      style={{ alignSelf: "flex-start" }}
                    >
                      {bulkLoading ? (
                        <CircularProgress size={24} />
                      ) : (
                        "Grant Feature"
                      )}
                    </Button>
                  </form>
                </TabPanel>
              </>
            ) : (
              <Box p={2}>Unauthorized: Permission to manage Features required. Please contact Admin</Box>
            )}
          </TabPanel>
        </div>

        {this.renderBulkDetailsDialog()}

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={snackbarOpen}
          onClose={this.handleSnackbarClose}
        >
          <Alert
            onClose={this.handleSnackbarClose}
            severity={snackbarSeverity}
            action={
              <>
                {snackbarShowErrorDetails && (
                  <Button
                    color="inherit"
                    size="small"
                    onClick={() =>
                      this.setState({ openBulkFailuresDialog: true })
                    }
                  >
                    Details
                  </Button>
                )}
                <IconButton
                  aria-label="close"
                  size="small"
                  onClick={this.handleSnackbarClose}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </>
            }
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
        </>
      </MuiPickersUtilsProvider>
    );
  }
}

export default FeatureAccess;
